var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-table-index",
      attrs: { id: _vm.value, name: _vm.value },
    },
    [
      _c(
        "el-table",
        {
          staticClass: "form-table",
          attrs: {
            "row-key": function (record) {
              return record.key
            },
            data: _vm.value,
          },
        },
        [
          _vm.isVisible
            ? [
                _c("el-table-column", {
                  attrs: {
                    label: "序号",
                    align: "center",
                    type: "index",
                    width: "50",
                  },
                }),
                _vm._l(_vm.item.childList, function (option, index) {
                  return [
                    _c("el-table-column", {
                      key: index,
                      attrs: {
                        align: "center",
                        label: _vm.getTableColumnLabel(option),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.showText(scope.row, option.vModel)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center", width: "300" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateDomain(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 修改 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copyDomain(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 复制 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeDomain(scope.$index)
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    409492857
                  ),
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "add-button" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text", disabled: _vm.disabled },
              on: { click: _vm.addDomain },
            },
            [_vm._v(" 增加一行 ")]
          ),
        ],
        1
      ),
      _vm.addOrUpdateVisible
        ? _c("AddOrUpdate", {
            ref: "addOrUpdate",
            attrs: {
              pageShowMore: _vm.pageShowMore,
              fields: _vm.item.childList,
            },
            on: { submit: _vm.handleFormSubmit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }